export const capitalizeKey = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

export const appStoreKey = (suffix: string) => `appStore.${suffix}`;

export const relatedAppNameKey = (i18nKey: string) =>
  appStoreKey(`related${capitalizeKey(i18nKey)}Name`);

export const relatedAppSubtitleKey = (i18nKey: string) =>
  appStoreKey(`related${capitalizeKey(i18nKey)}Subtitle`);

export const reviewFieldKey = (i18nKey: string, field: string) =>
  appStoreKey(`review${capitalizeKey(i18nKey)}${capitalizeKey(field)}`);

export const privacyCardKey = (i18nKey: string, field: 'Title' | 'Description') =>
  appStoreKey(`privacy${capitalizeKey(i18nKey)}${field}`);

export const privacyItemKey = (i18nKey: string) =>
  appStoreKey(`privacyItem${capitalizeKey(i18nKey)}`);

export const informationRowKey = (labelKey: string) =>
  appStoreKey(`information${capitalizeKey(labelKey)}`);

export const informationLinkKey = (i18nKey: string) =>
  appStoreKey(`informationLink${capitalizeKey(i18nKey)}`);

export const tabBarKey = (labelKey: string) =>
  appStoreKey(`tabBar${capitalizeKey(labelKey)}`);

export const relatedSectionKey = (titleKey: string) =>
  appStoreKey(`related${titleKey}`);
